module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_06_11_entertainment_orlando-christina-grimmie-shot_index.html_plot.8c800c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_06_11_entertainment_orlando-christina-grimmie-shot_index.html_plot.png
// module id = 369
// module chunks = 0